import React          from 'react';
import { Link }       from 'react-router-dom';
import * as PropTypes from 'prop-types';

const SearchPageItem = (props) => {
  const {
          label,
          urlKey,
          close
        } = props;

  return (
    <Link
      to={urlKey}
      className={'item new inline'}
      onClick={close}
    >
      <div>
        <div className={'title'}>
          {label}
        </div>
      </div>
    </Link>
  );
};

SearchPageItem.propTypes = {
  close:  PropTypes.func.isRequired,
  label:  PropTypes.string.isRequired,
  urlKey: PropTypes.string.isRequired
};

export default SearchPageItem;